import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { IGoogleAdsAdText } from '@feathr/blackbox';

import type { IInputListItemSharedProps } from './InputListItem';
import InputListItem from './InputListItem';

interface IInputListProps extends IInputListItemSharedProps {
  items: IGoogleAdsAdText[];
  minItems: number;
  maxItems: number;
  /** Messages for the rows that have any, keyed by row key. */
  errors?: Record<string, string[]>;
}

function InputList({
  items,
  errors,
  label,
  maxLength,
  maxItems,
  minItems,
  onChange,
  onRemove,
  removeTooltip,
  type = 'input',
}: Readonly<IInputListProps>): JSX.Element {
  const canRemove = items.length > minItems && items.length <= maxItems;
  return (
    <>
      {items.map((item, index) => {
        return (
          <InputListItem
            canRemove={canRemove}
            index={index}
            item={item.text}
            key={item.key}
            label={label}
            maxLength={maxLength}
            onChange={onChange}
            onRemove={onRemove}
            removeTooltip={removeTooltip}
            type={type}
            validationError={errors?.[item.key]}
          />
        );
      })}
    </>
  );
}

export default observer(InputList);
